module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAKFJREFUOBGNk1kOgzAMRF3u/0HLD8txulwLZlCCplGwHWkUh/gNmMRmZj/oBT2g7GDuBH0JEN6hFcqYMGcrzIj5hJbyIDJRmMz1QgaRicKzwojP4ZmEsGeShu9M6g/rfnaF2lnL4QndwkNLylr3NJaUftjWHJ3On0sLc63luPekB1f30MSDQ5MM7Jqwq9yjqnSZtRw2on0gdhU3soO5T+h9AK28PU67BZj6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/03.png
// module id = 148
// module chunks = 1